
const input = document.querySelector('.search-modal__form .field__label');
const placeholders = [
    'Jet Boat Impellers',
    'Flyboard Impellers',
    'Pumps',
    'Parts & Tools'
];
const searchFor = "Search for ";

let currentIndex = 0; // Tracks the current placeholder index
let charIndex = 0; // Tracks the current character being typed or deleted
let isDeleting = false; // Whether we are in the deleting phase
const typingSpeed = 100; // Speed of typing in milliseconds
const deletingSpeed = 50; // Speed of deleting in milliseconds
const pauseBetweenWords = 1000; // Pause before starting to delete
function typeEffect() {
    const currentPlaceholder = placeholders[currentIndex]; // Get the current placeholder

    if (!isDeleting) {
        // Typing phase: Add one character at a time
        charIndex++;
    } else {
        // Deleting phase: Remove one character at a time
        charIndex--;
    }

    // Update the placeholder text
    input.innerText = ('placeholder', searchFor + currentPlaceholder.slice(0, charIndex));

    if (!isDeleting && charIndex === currentPlaceholder.length) {
        // Pause after fully typing the word
        setTimeout(() => {
            isDeleting = true;
            typeEffect(); // Continue the loop
        }, pauseBetweenWords);
        return;
    } else if (isDeleting && charIndex === 0) {
        // Move to the next word after deleting
        isDeleting = false;
        currentIndex = (currentIndex + 1) % placeholders.length; // Cycle back to the first word
    }

    // Adjust speed based on typing or deleting
    const speed = isDeleting ? deletingSpeed : typingSpeed;

    setTimeout(typeEffect, speed);
}
if(input != null){
// Start the typing effect
typeEffect();
}

